import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, ShoppingBagIcon, BookOpenIcon, UserIcon } from '@heroicons/react/24/outline';
import { HomeIcon as HomeIconSolid, ShoppingBagIcon as ShopSolid, BookOpenIcon as BookSolid, UserIcon as UserSolid } from '@heroicons/react/24/solid';

const TABS = [
  { to: '/', label: 'Beranda', Icon: HomeIcon, ActiveIcon: HomeIconSolid },
  { to: '/seller', label: 'Toko', Icon: ShoppingBagIcon, ActiveIcon: ShopSolid },
  { to: '/library', label: 'Library', Icon: BookOpenIcon, ActiveIcon: BookSolid },
  { to: '/profile', label: 'Profil', Icon: UserIcon, ActiveIcon: UserSolid },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 flex">
      {TABS.map(({ to, label, Icon, ActiveIcon }) => {
        const active = pathname === to;
        const I = active ? ActiveIcon : Icon;
        return (
          <Link key={to} to={to} className={`flex-1 flex flex-col items-center py-2 text-xs ${active ? 'text-wa-dark' : 'text-gray-500'}`}>
            <I className="w-5 h-5 mb-0.5" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
